export function deleteLastSelectedRangeComponents(scene) {
    scene.selectedRangeComponents.forEach(((selectComp, key) => {
        var _a;
        key.split("-")[4] === scene.lastSelectId && (selectComp.rect.delete(), null === (_a = selectComp.fillhandle) || void 0 === _a || _a.delete(), 
        scene.selectedRangeComponents.delete(key));
    }));
}

export function deleteAllSelectBorder(scene) {
    scene.selectedRangeComponents.forEach(((selectComp, key) => {
        var _a;
        selectComp.rect.delete(), null === (_a = selectComp.fillhandle) || void 0 === _a || _a.delete();
    })), scene.selectedRangeComponents = new Map;
}

export function deleteAllSelectingBorder(scene) {
    scene.selectingRangeComponents.forEach(((selectComp, key) => {
        var _a;
        selectComp.rect.delete(), null === (_a = selectComp.fillhandle) || void 0 === _a || _a.delete();
    })), scene.selectingRangeComponents = new Map;
}

export function removeFillHandleFromSelectComponents(scene) {
    scene.selectedRangeComponents.forEach(((selectComp, key) => {
        var _a;
        null === (_a = selectComp.fillhandle) || void 0 === _a || _a.delete(), selectComp.fillhandle = void 0;
    }));
}
//# sourceMappingURL=delete-select-border.js.map
